module.exports = __webpack_public_path__ + "static/media/detail_0003_t.f5a45994.jpg";